import React, { FC } from "react";
import { Link } from "react-router-dom";
import { SideProps } from ".";
import { useSelector } from "react-redux";
import { loginSliceValue } from "../../redux/reducers/loginSlice";

const RTMAdminSidebar: FC<SideProps> = ({ currentMenu }) => {
  const { userDetails } = useSelector(loginSliceValue);

  return (
    <nav className="navigation">
      <ul className="navigation__list">
        <li className="navigation__list--link">
          <img
            src="/assets/LogoNew_White.png"
            alt="clinIQ™ Logo"
            className="navigation__logo"
          />
        </li>
        <li className="navigation__list--item">
          <Link
            to="/patient"
            className={
              currentMenu === "patient"
                ? "navigation__list--link-active"
                : "navigation__list--link"
            }
          >
            <svg
              className={
                currentMenu === "patient"
                  ? "navigation__icon-active"
                  : "navigation__icon"
              }
            >
              <use xlinkHref={`/assets/sprite.svg#icon-rtm`} />
            </svg>
            <span>RTM</span>
          </Link>
        </li>
        {/* 
               <li className="navigation__list--item">
                 <Link
                   to="/plan-patient-list"
                   className={
                     currentMenu === "plan-patient-list"
                       ? "navigation__list--link-active"
                       : "navigation__list--link"
                   }
                 >
                   <svg
                     className={
                       currentMenu === "plan-patient-list"
                         ? "navigation__icon-active"
                         : "navigation__icon"
                     }
                   >
                     <use xlinkHref={`/assets/sprite.svg#icon-feedback`} />
                   </svg>
                   <span>Plan Patient List</span>
                 </Link>
               </li> */}
      </ul>

      <div>
        <Link
          to="/my-profile"
          className={
            currentMenu === "my-profile"
              ? "navigation__list--link-active"
              : "navigation__list--link"
          }
        >
          <svg
            className={
              currentMenu === "my-profile"
                ? "navigation__icon-active"
                : "navigation__icon"
            }
          >
            <use xlinkHref={`/assets/sprite.svg#icon-users2`} />
          </svg>
          <span>My Profile</span>
        </Link>

        <p className="powered__text">
          <span>
            Powered By
            <br />
            <a
              href="https://www.the-algo.com/"
              target="_blank"
              rel="noreferrer"
            >
              The Algorithm
            </a>
          </span>
          &copy; {new Date(Date.now()).getFullYear()}. clinIQ
        </p>
      </div>
    </nav>
  );
};

export default RTMAdminSidebar;
